'use strict';

// css
import './scss/styles.scss';

// js
import $ from 'jquery';
// import mask from 'jquery-mask-plugin';
// import selectToLinks from './js/jquery-select-to-links';
import owlCarousel from '../node_modules/owl.carousel/dist/owl.carousel.min';

// yii
import yii from '../vendor/yiisoft/yii2/assets/yii';
import yiiActiveForm from '../vendor/yiisoft/yii2/assets/yii.activeForm';
import yiiValidation from '../vendor/yiisoft/yii2/assets/yii.validation';

global.$ = global.jQuery = $;

// common
$(function () {
    const $body = $('body');

    // $('input[type=tel]').mask('+7 (999) 999-99-99');
    // $('select').selectToLinks();

    // лучшее за неделю/месяц
    $(".best-news__toggle").click(function (e) {
        e.preventDefault();

        if ($(this).hasClass('best-news__toggle_active')) {
            return;
        }

        $('.best-news__toggle_active').toggleClass('best-news__toggle_active');
        $(this).toggleClass('best-news__toggle_active');

        $(".best-news__list").hide();
        $($(this).attr('href')).show();
    });


    /** ПОИСК **/
    (function () {

        const $form = $('[data-form="search"]').find('form');

        if (!$form.length)
            return false;

        const $btn = $form.find('button[type="button"]');
        const $inp = $form.find('input[type="search"]');

        const check = function () {
            const value = $inp.val();
            const is_focused = $inp.is(':focus');

            const activeElement = $(document.activeElement);

            if ((value && value != '') || activeElement.hasClass('inp--search'))
                $form.addClass('toggled');
            else
                $form.removeClass('toggled');

        };

        check();

        $inp.on('focus blur change keyup', function () {
            check();
        });

        $btn.on('click', function (e) {
            $inp.focus();
        });

    })();

    /** ФОТО/ВИДЕО **/
    (function () {

        // var $section = $('[data-section="gallery"]');
        //
        // if (!$section.length) return false;

        const $carousel = $('.owl-carousel');

        const carousel = $carousel.owlCarousel({
            css: true,
            loop: false,
            responsiveClass: false,
            smartSpeed: 400,
            fluidSpeed: 400,
            margin: 20,
            navText: ["", ""],
            responsive: {
                0: {
                    dots: true,
                    nav: false,
                    autoWidth: false,
                    margin: 0,
                    items: 1
                },
                768: {
                    dots: false,
                    nav: true,
                    autoWidth: true,
                    margin: 20,
                    items: 3
                }
            }
        });

    })();
});
